export const getCookieValue = name => {
  if (!name) return null

  const escaped = name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1')
  const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'))

  return match ? decodeURIComponent(match[1]) : null
}

export const setCookieValue = (name, value, days = 365, opts = {}) => {
  const maxAge = '; Max-Age=' + days * 24 * 60 * 60
  const secure = location.protocol === 'https:' ? '; Secure' : ''
  const sameSite = opts.sameSite ? `; SameSite=${opts.sameSite}` : '; SameSite=Lax'
  const path = opts.path ? `; Path=${opts.path}` : '; Path=/'
  const domain = opts.domain ? `; Domain=${opts.domain}` : ''

  document.cookie = `${name}=${encodeURIComponent(value)}${path}${domain}${maxAge}${sameSite}${secure}`
}

export const getCookieDomain = () => {
  const parts = location.hostname.split('.')
  return '.' + parts.slice(-2).join('.')
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/cookie/index.js